import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Time from "../../Time/Time";
import Translator from "../../Translation/Translator";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import ChargeTemplateFactory from "../../Entity/Factories/ChargeTemplateFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";
import { MainTenant } from "../../Entity/Entities/ContactForContract/Type/Types/MainTenant";

export default function* contractUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_ERRORS_CLEAR
    });

    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_REQUEST
    });

    const contactForContracts: any[] = [];

    // First, we have to push Tenant into the array of Persons.
    if (!!action.payload?.selectedPerson) {
      contactForContracts.push({
      contactId: action.payload?.сreatedFromCoach ? null : action.payload?.selectedPerson?.id || null,
      contractPartyDescription: "Tenant",
      contactForContractTypeId: MainTenant.contactForContractTypeId
    });
  }

    // If we have additional fields, we have to push those into the array too.
    !!action.payload?.additionalFields.length && action.payload?.additionalFields.forEach(field => {
      if (!field) {
        return;
      }

      if (typeof field.selectedPerson === "undefined") {
        return;
      }

      contactForContracts.push({
        contactId: field.selectedPerson && field.selectedPerson.id,
        contractPartyDescription: field.description,
        contactForContractTypeId: field.contactForContractTypeId
      });
    });

    const res = yield call(Http.put, `contract/${action.payload?.contract.id}`, {
      contractStatusId: action.payload?.contract?.status,
      note: action.payload?.contract.note,
      checkinDate: null,
      checkoutDate: null,
      contactForContracts: contactForContracts,
      mainTenantContactId: action.payload?.selectedPerson?.id,
      mainTenantCompanyId: action.payload?.selectedCompany?.id,
      firstDate: Time.formatOrNull(action.payload?.contract.firstDate),
      lastDate: Time.formatOrNull(action.payload?.contract.lastDate),
      finalRentalPeriodDate: Time.formatOrNull(action.payload?.contract.finalRentalPeriodDate),
      expirationDate: Time.formatOrNull(action.payload?.contract.expirationDate),
      payChargesUntil: Time.formatOrNull(action.payload?.contract.payChargesUntilDate),
      unitId: action.payload?.unitId,
      autoSendInvoiceToTenant: action?.payload?.autoSendInvoiceToTenant,
      addressForRentEmail: action?.payload?.addressForRentEmail,
      isCommercial: action.payload?.isCommercial,
      chargeTemplates: !!action.payload?.chargeTemplates.length && action.payload?.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        return {
          id: chargeTemplate.id,
          amount: chargeTemplate.amount,
          currency: chargeTemplate.currency.getCurrencyId(),
          type: chargeTemplate.type.id,
          repeatPeriod: chargeTemplate?.repeatPeriod?.id,
          description: chargeTemplate.description,
          paymentOffset: chargeTemplate.paymentOffset?.getValue(),
          dueDateFirstPayment: Time.formatOrNull(chargeTemplate.dueDateFirstPayment),
          firstDate: Time.formatOrNull(chargeTemplate.firstDate),
          endDate: Time.formatOrNull(chargeTemplate.endDate),
          contactId: chargeTemplate.contactId,
          companyId: chargeTemplate.companyId,
          isCollective: chargeTemplate?.isCollective
        };
      })
    });

    const contract: ContractInterface = ContractFactory.create(res.data.data);

    // Update contract
    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_SUCCESS,
      payload: {
        contract: contract,
        unitId: action.payload?.unitId,
        chargeTemplates: action.payload?.chargeTemplates
      }
    });

    // Update each charge template
    yield res.data.data.chargeTemplates.map((data: ChargeTemplateInterface) => {
      const chargeTemplate: ChargeTemplateInterface = ChargeTemplateFactory.create(data);

      return put({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_SUCCESS,
        payload: {
          chargeTemplate: chargeTemplate
        }
      });
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-contract-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, contract);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchContractUpdate() {
  yield takeEvery(Constants.PAGE_CONTRACT_UPDATE_START, contractUpdate);
}
